import * as angular from 'angular';

(function () {
    'use strict';

    angular.module('app').filter('time', function () {
        var conversions = {
            ss: angular.identity,
            mm: function (value) {
                return value * 60;
            },
            hh: function (value) {
                return value * 3600;
            },
        };

        var padding = function (value, length) {
            var zeroes = length - ('' + value).length,
                pad = '';
            while (zeroes-- > 0) pad += '0';
            return pad + value;
        };

        return function (value, unit, format, isPadded) {
            var totalSeconds = conversions[unit || 'ss'](value),
                hh = Math.floor(totalSeconds / 3600),
                mm = Math.floor((totalSeconds % 3600) / 60),
                ss = totalSeconds % 60;

            format = format || 'hh:mm:ss';
            isPadded = angular.isDefined(isPadded) ? isPadded : true;
            var ret_hh = isPadded ? padding(hh, 2) : hh;
            var ret_mm = isPadded ? padding(mm, 2) : mm;
            var ret_ss = isPadded ? padding(ss, 2) : ss;

            return format.replace(/hh/, ret_hh).replace(/mm/, ret_mm).replace(/ss/, ret_ss);
        };
    });
})();



// WEBPACK FOOTER //
// ./node_modules/angularjs-template-loader??ref--0-1!./src/app/filters/time.filter.ts